export default "__VITE_ASSET__RXxB5v0v__"